import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_wave = _resolveDirective("wave")!

  return _withDirectives((_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
			'flex-center',
			'c-button-icon',
			`c-button-icon-${_ctx.type}`,
			`c-button-icon-${_ctx.color}`,
			{ [_ctx.activeClass]: _ctx.isActive },
		])
  }, [
    _createVNode(_component_font_awesome_icon, { icon: _ctx.iconName }, null, 8, ["icon"])
  ], 2)), [
    [_directive_wave]
  ])
}